module.exports = __webpack_public_path__ + "img/beauty-garden.d0fc906a.png";